<template>
  <table class="listado table table-hover">
    <thead class="bg-primary text-white">
      <th-ordenado titulo="Nombre" campo="nombre" />
      <th-ordenado titulo="Meses" campo="meses" />
      <th class="th-acciones">Acciones</th>
    </thead>
    <tbody>
      <sin-registros v-if="!duracionesContrato" :colspan="4" />
      <tr v-for="(duracionContrato, idx) in duracionesContrato" :key="idx" role="button">
        <td @click="editarDuracionContrato(duracionContrato.id)">
          {{ duracionContrato.nombre }}
        </td>
        <td @click="editarDuracionContrato(duracionContrato.id)">
          {{ duracionContrato.meses }}
        </td>
        <td nowrap="nowrap" class="td-acciones">
          <b-button
            size="sm"
            v-show="duracionContrato.id > 0"
            :to="`/duracionesContrato/descuentos/${duracionContrato.id}`"
            type="button"
            variant="dark"
          >
            Descuentos
          </b-button>
          &nbsp;
          <b-button-group size="sm">
            <b-button variant="primary" class="actionButton" :to="`/duracionesContrato/editar/${duracionContrato.id}`">
              <v-icon variant="primary" name="edit" width="16" /><span>Editar</span>
            </b-button>
          </b-button-group>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: {
    duracionesContrato: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    editarDuracionContrato(duracionContratoId) {
      this.$router.push("/duracionesContrato/editar/" + duracionContratoId);
    },
  },
};
</script>
